// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_fu-1";
export var quotedThread = "_fu-0";